import { render, staticRenderFns } from "./VideoSpecimenList.vue?vue&type=template&id=98d7ddf8&scoped=true"
import script from "./VideoSpecimenList.vue?vue&type=script&lang=js"
export * from "./VideoSpecimenList.vue?vue&type=script&lang=js"
import style0 from "./VideoSpecimenList.vue?vue&type=style&index=0&id=98d7ddf8&prod&lang=css"
import style1 from "./VideoSpecimenList.vue?vue&type=style&index=1&id=98d7ddf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d7ddf8",
  null
  
)

export default component.exports